
import "./Button.css"
const Button = ({ title, onClick, disabled = false, second = false }) => {
  return <button type="button" className={`btn btn-primary ${second ? 'btn-second' : 'btn-anny'} btn-lg ${disabled && 'disabled'}`} onClick={() => onClick()}>{title}</button>
}

export default Button